// import { loginAmplitude, logoutAmplitude } from './amplitude';

// Hides the Intercom chat widget for "Login as user" sessions.
// index.html sets window.intercomSettings, so the widget starts as an anonymous
// visitor on page load. hide_default_launcher stops the chat bubble from showing
// if the widget hasn't loaded yet; shutdown removes it if it already has.
export const hideIntercomForLimitedUser = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.intercomSettings = { ...(window.intercomSettings || {}), hide_default_launcher: true };

  if (typeof window.Intercom === 'function') {
    window.Intercom('shutdown');
  }
};

export const loginIntercomUser = (currentUser, app_id) => {
  if (typeof window.Intercom === 'undefined') {
    
    return;
  }

  if (!currentUser || !currentUser.id) {
    return;
  }

  const profile = currentUser.attributes.profile;

  const intercomSettings = window.intercomSettings || {
    app_id,
  };

  intercomSettings.user_id = currentUser.id.uuid;
  intercomSettings.email = currentUser.attributes.email;
  intercomSettings.phone = profile.protectedData.phoneNumber;
  intercomSettings.name = `${profile.firstName} ${profile.lastName}`;
  // Show the chat bubble again: a "Login as user" session earlier in this page may have hidden it,
  // and logout doesn't reload the page
  delete intercomSettings.hide_default_launcher;

  window.Intercom('shutdown');
  window.Intercom('boot', intercomSettings);

  // loginAmplitude({
  //   userId: `${currentUser.id.uuid} - ${intercomSettings.email}`,
  //   userData: {
  //     Email: intercomSettings.email,
  //     Phone: intercomSettings.phone,
  //     Name: intercomSettings.name,
  //   }
  // });
};

// Not Intercom-specific: sendEventGeneral reads this key, so it must be saved
// for every logged-in user, including "Login as user" sessions.
export const saveUserVerificationKey = currentUser => {
  if (typeof window.localStorage !== 'undefined') {
    window.localStorage.setItem('uvk', currentUser.attributes.profile.privateData.userVerificationKey);
  }
};

export const logoutIntercomUser = (app_id) => {
  if (typeof window.Intercom === 'undefined') {
    return;
  }

  const intercomSettings = {
    app_id,
    user_id: null,
    email: null,
    phone: null,
    name: null,
    role: null,
  };

  window.Intercom('shutdown');
  window.Intercom('boot', intercomSettings);

  if (typeof window.localStorage !== 'undefined') {
    window.localStorage.removeItem('uvk');
  }

  // logoutAmplitude();
};
